import { faMailbox } from "@fortawesome/pro-duotone-svg-icons/faMailbox";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_MAILBOXES_LINK: Breadcrumb = {
  icon: faMailbox,
  name: "Mailboxes",
  to: "/dashboard/triggers/mailboxes",
};
